<template>
  <div class="row">
    <!-- DIAMOND -->
    <div class="col-md-6 diamond">
      <h3>Number of Stones</h3>
      <span class="highlighted">* baguettes are valued at $0</span>
      <div class="row">
        <label for="calc_01">0.01</label>
        <input class="input" id="calc_01" @input="calc_01" />
      </div>
      <div class="row">
        <label for="calc_02">0.02</label>
        <input class="input" id="calc_02" @input="calc_02" />
      </div>
      <div class="row">
        <label for="calc_03">0.03</label>
        <input class="input" id="calc_03" @input="calc_03" />
      </div>
      <div class="row">
        <label for="calc_04">0.04</label>
        <input class="input" id="calc_04" @input="calc_04" />
      </div>
      <div class="row">
        <label for="calc_05">0.05</label>
        <input class="input" id="calc_05" @input="calc_06" />
      </div>
      <div class="row">
        <label for="calc_06">0.06</label>
        <input class="input" id="calc_06" @input="calc_07" />
      </div>
      <div class="row">
        <label for="calc_07">0.07</label>
        <input class="input" id="calc_07" @input="calc_07" />
      </div>
      <div class="row">
        <label for="calc_08">0.08</label>
        <input class="input" id="calc_08" @input="calc_08" />
      </div>
      <div class="row">
        <label for="calc_09">0.09</label>
        <input class="input" id="calc_09" @input="calc_09" />
      </div>
      <div class="row">
        <label for="calc_10">0.10</label>
        <input class="input" id="calc_10" @input="calc_10" />
      </div>
      <div class="row">
        <label for="calc_15">0.15</label>
        <input class="input" id="calc_15" @input="calc_15" />
      </div>
      <div class="row">
        <label for="calc_20">0.20</label>
        <input class="input" id="calc_20" @input="calc_20" />
      </div>
      <div class="row">
        <label for="calc_25">0.25</label>
        <input class="input" id="calc_25" @input="calc_25" />
      </div>
      <div class="row">
        <label for="calc_33">0.33</label>
        <input class="input" id="calc_33" @input="calc_33" />
      </div>
      <div class="row">
        <label for="calc_40">0.40</label>
        <input class="input" id="calc_40" @input="calc_40" />
      </div>
      <div class="row">
        <label for="calc_50">0.50</label>
        <input class="input" id="calc_50" @input="calc_50" />
      </div>
      <div class="row">
        <label for="calc_66">0.66</label>
        <input class="input" id="calc_66" @input="calc_66" />
      </div>
      <div class="row">
        <label for="calc_75">0.75</label>
        <input class="input" id="calc_75" @input="calc_75" />
      </div>
      <div class="row">
        <label for="calc_100">1.00</label>
        <input class="input" id="calc_100" @input="calc_100" />
      </div>
      <p class="diamond_subtotal">Diamond Subtotal: ${{ diamond_subtotal | twoDecimals }}</p>
    </div>
    <!-- GOLD -->
    <div class="col-md-6 gold">
      <h3>Gold Weight</h3>
      <span class="highlighted">GRAMS - remember to subtract estimated stone weight</span>
      <div class="row">
        <label for="calc_10k">10K</label>
        <input class="input" id="calc_10k" @input="calc_10k" />
      </div>
      <div class="row">
        <label for="calc_14k">14K</label>
        <input class="input" id="calc_14k" @input="calc_14k" />
      </div>
      <div class="row">
        <label for="calc_18k">18K</label>
        <input class="input" id="calc_18k" @input="calc_18k" />
      </div>
    </div>
    <!-- TOTALS -->
    <div class="container my-5">
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col"></th>
            <th scope="col" class="bg-green">Gold Only or Eye Clean Round Stones</th>
            <th scope="col" class="bg-yellow">Square Marquis or Yellow</th>
            <th scope="col" class="bg-red">Frozen Spit</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">New Customer to 60% RR Loan Up To</th>
            <td>${{ total1 | twoDecimals }}</td>
            <td>${{ total7 | twoDecimals }}</td>
            <td>${{ total13 | twoDecimals }}</td>
          </tr>
          <tr>
            <th scope="row">60%-70% RR Loan Up To</th>
            <td>${{ total2 | twoDecimals }}</td>
            <td>${{ total8 | twoDecimals }}</td>
            <td>${{ total14 | twoDecimals }}</td>
          </tr>
          <tr>
            <th scope="row">70%-80% RR Loan Up To</th>
            <td>${{ total3 | twoDecimals }}</td>
            <td>${{ total9 | twoDecimals }}</td>
            <td>${{ total15 | twoDecimals }}</td>
          </tr>
          <tr>
            <th scope="row">80%-90% RR Loan Up To</th>
            <td>${{ total4 | twoDecimals }}</td>
            <td>${{ total10 | twoDecimals }}</td>
            <td>${{ total16 | twoDecimals }}</td>
          </tr>
          <tr>
            <th scope="row">80%-100% RR Loan Up To</th>
            <td>${{ total5 | twoDecimals }}</td>
            <td>${{ total11 | twoDecimals }}</td>
            <td>${{ total17 | twoDecimals }}</td>
          </tr>
          <tr>
            <th scope="row">Buy Up To (USE AS MAX)</th>
            <td>${{ total6 | twoDecimals }}</td>
            <td>${{ total12 | twoDecimals }}</td>
            <td>${{ total18 | twoDecimals }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <button class="btn btn-danger w-100" @click="reset">Reset</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      numStones_01: 0,
      numStones_02: 0,
      numStones_03: 0,
      numStones_04: 0,
      numStones_05: 0,
      numStones_06: 0,
      numStones_07: 0,
      numStones_08: 0,
      numStones_09: 0,
      numStones_10: 0,
      numStones_15: 0,
      numStones_20: 0,
      numStones_25: 0,
      numStones_33: 0,
      numStones_40: 0,
      numStones_50: 0,
      numStones_66: 0,
      numStones_75: 0,
      numStones_100: 0,
      PPC_01: 32.5 / 4,
      PPC_02: 32.5 / 4,
      PPC_03: 35 / 4,
      PPC_04: 35 / 4,
      PPC_05: 35 / 4,
      PPC_06: 40 / 4,
      PPC_07: 40 / 4,
      PPC_08: 40 / 4,
      PPC_09: 40 / 4,
      PPC_10: 80 / 2,
      PPC_15: 100 / 2,
      PPC_20: 125 / 2,
      PPC_25: 150 / 2,
      PPC_33: 160 / 2,
      PPC_40: 300 / 2,
      PPC_50: 450 / 1.7,
      PPC_66: 500 / 1.5,
      PPC_75: 600 / 1.5,
      PPC_100: 700 / 1.5,
      weight_10k: 0,
      weight_14k: 0,
      weight_18k: 0,
      GPG_10k: 16.25 / 1.3,
      GPG_14k: 20,
      GPG_18k: 35 / 1.3
    };
  },
  methods: {
    calc_01(event) {
      this.numStones_01 = event.target.value * 0.01 * this.PPC_01;
    },
    calc_02(event) {
      this.numStones_02 = event.target.value * 0.02 * this.PPC_02;
    },
    calc_03(event) {
      this.numStones_03 = event.target.value * 0.03 * this.PPC_03;
    },
    calc_04(event) {
      this.numStones_04 = event.target.value * 0.04 * this.PPC_04;
    },
    calc_05(event) {
      this.numStones_05 = event.target.value * 0.05 * this.PPC_05;
    },
    calc_06(event) {
      this.numStones_06 = event.target.value * 0.06 * this.PPC_06;
    },
    calc_07(event) {
      this.numStones_07 = event.target.value * 0.07 * this.PPC_07;
    },
    calc_08(event) {
      this.numStones_08 = event.target.value * 0.08 * this.PPC_08;
    },
    calc_09(event) {
      this.numStones_09 = event.target.value * 0.09 * this.PPC_09;
    },
    calc_10(event) {
      this.numStones_10 = event.target.value * 0.1 * this.PPC_10;
    },
    calc_15(event) {
      this.numStones_15 = event.target.value * 0.15 * this.PPC_15;
    },
    calc_20(event) {
      this.numStones_20 = event.target.value * 0.2 * this.PPC_20;
    },
    calc_25(event) {
      this.numStones_25 = event.target.value * 0.25 * this.PPC_25;
    },
    calc_33(event) {
      this.numStones_33 = event.target.value * 0.33 * this.PPC_33;
    },
    calc_40(event) {
      this.numStones_40 = event.target.value * 0.4 * this.PPC_40;
    },
    calc_50(event) {
      this.numStones_50 = event.target.value * 0.5 * this.PPC_50;
    },
    calc_66(event) {
      this.numStones_66 = event.target.value * 0.66 * this.PPC_66;
    },
    calc_75(event) {
      this.numStones_75 = event.target.value * 0.75 * this.PPC_75;
    },
    calc_100(event) {
      this.numStones_100 = event.target.value * 1 * this.PPC_100;
    },
    calc_10k(event) {
      this.weight_10k = event.target.value * 1;
    },
    calc_14k(event) {
      this.weight_14k = event.target.value * 1;
    },
    calc_18k(event) {
      this.weight_18k = event.target.value * 1;
    },
    reset() {
      this.numStones_01 = 0;
      this.numStones_02 = 0;
      this.numStones_03 = 0;
      this.numStones_04 = 0;
      this.numStones_05 = 0;
      this.numStones_06 = 0;
      this.numStones_07 = 0;
      this.numStones_08 = 0;
      this.numStones_09 = 0;
      this.numStones_10 = 0;
      this.numStones_15 = 0;
      this.numStones_20 = 0;
      this.numStones_25 = 0;
      this.numStones_33 = 0;
      this.numStones_40 = 0;
      this.numStones_50 = 0;
      this.numStones_66 = 0;
      this.numStones_75 = 0;
      this.numStones_100 = 0;
      this.weight_10k = 0;
      this.weight_14k = 0;
      this.weight_18k = 0;
      let inputFields = document.querySelectorAll(".input");
      inputFields.forEach(input => (input.value = ""));
    }
  },
  computed: {
    diamond_subtotal: function() {
      return (
        this.numStones_01 +
        this.numStones_02 +
        this.numStones_03 +
        this.numStones_04 +
        this.numStones_05 +
        this.numStones_06 +
        this.numStones_07 +
        this.numStones_08 +
        this.numStones_09 +
        this.numStones_10 +
        this.numStones_15 +
        this.numStones_20 +
        this.numStones_25 +
        this.numStones_33 +
        this.numStones_40 +
        this.numStones_50 +
        this.numStones_66 +
        this.numStones_75 +
        this.numStones_100
      );
    },
    total1: function() {
      let diamondSubtotal = this.diamond_subtotal;
      let multiplier = 0.86;
      let a = this.weight_10k * this.GPG_10k;
      let b = this.weight_14k * this.GPG_14k;
      let c = this.weight_18k * this.GPG_18k;

      let gold = a + b + c;

      return (diamondSubtotal + gold) * multiplier;
    },
    total2: function() {
      let total1 = this.total1;
      let multiplier = 1.05;

      return total1 * multiplier;
    },
    total3: function() {
      let total1 = this.total1;
      let multiplier = 1.1;

      return total1 * multiplier;
    },
    total4: function() {
      let total1 = this.total1;
      let multiplier = 1.15;

      return total1 * multiplier;
    },
    total5: function() {
      let total1 = this.total1;
      let multiplier = 1.2;

      return total1 * multiplier;
    },
    total6: function() {
      let total5 = this.total5;
      let multiplier = 1;

      return total5 * multiplier;
    },
    total7: function() {
      let total1 = this.total1;
      let multiplier = 0.8;

      return total1 * multiplier;
    },
    total8: function() {
      let total2 = this.total2;
      let multiplier = 0.8;

      return total2 * multiplier;
    },
    total9: function() {
      let total3 = this.total3;
      let multiplier = 0.8;

      return total3 * multiplier;
    },
    total10: function() {
      let total4 = this.total4;
      let multiplier = 0.8;

      return total4 * multiplier;
    },
    total11: function() {
      let total5 = this.total5;
      let multiplier = 0.8;

      return total5 * multiplier;
    },
    total12: function() {
      let total11 = this.total11;
      let multiplier = 1;

      return total11 * multiplier;
    },
    total13: function() {
      let total1 = this.total1;
      let multiplier = 0.6;

      return total1 * multiplier;
    },
    total14: function() {
      let total2 = this.total2;
      let multiplier = 0.6;

      return total2 * multiplier;
    },
    total15: function() {
      let total3 = this.total3;
      let multiplier = 0.6;

      return total3 * multiplier;
    },
    total16: function() {
      let total4 = this.total4;
      let multiplier = 0.6;

      return total4 * multiplier;
    },
    total17: function() {
      let total5 = this.total5;
      let multiplier = 0.6;

      return total5 * multiplier;
    },
    total18: function() {
      let total17 = this.total17;
      let multiplier = 1;

      return total17 * multiplier;
    }
  },
  filters: {
    twoDecimals: function(value) {
      return value.toFixed(2);
    }
  }
};
</script>

<style></style>
